import api from "api";


export function addAssignee(payload){
    return api.post(`/add-assignee`, payload);
}

export function updateAssignee(payload){
    return api.put(`/update-assignee`, payload);
}

export function getResolveApi(page = 1, limit = 10, search = '') {
    return api.get(`ticket-resolve-assignee?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`);
}
export function deleteAssignee(payload) {
    return api.delete(`/delete-assignee`, { data: payload });
}
